import { Box } from '@mui/material';
import styled from 'styled-components';

export const InfoBox = styled(Box)`
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
